import { setMeta } from '@/helpers/metaHelpers.js'

const seo = {
  watch: {
    $page: {
      handler: function (to) {
        setMeta(to.seo)
      },
    },
    'route.name': {
      immediate: true,
      handler() {
        if (this.$page) setMeta(this.$page.seo)
      },
    },
  },
}

export default seo
